
/**
 * Generate Organization schema for the homepage
 */
export function generateOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Grandpal",
    "url": "https://www.grandpal.ie",
    "logo": "https://www.grandpal.ie/lovable-uploads/b67e8743-f24e-45cd-ba77-2a1ae609411c.png",
    "description": "Helping families find nursing homes in Ireland and navigate the Fair Deal scheme with expert guidance.",
    "sameAs": [
      "https://www.facebook.com/grandpal.ie",
      "https://twitter.com/grandpal_ie",
      "https://www.linkedin.com/company/grandpal"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+353-1-234-5678",
      "contactType": "customer service",
      "areaServed": "IE",
      "availableLanguage": "English"
    }
  };
}
